import { Link } from "react-router-dom";
import './notFound.css'; 

export default function NotFound() {
    return (
        <div className="errorText">
            <h1>Oops! You seem to be lost.</h1>
            <Link to='/'>Return to Home Page</Link>
        </div>
    )
}